import { AddSquareOutline, FundingWalletOutline, HistoryOutline, PnlOutline, UsersOutline, CardOutline } from '@coinlocally/cly-core/icons';
import { useTranslation } from 'react-i18next';
import { IDashboardConfig } from 'shared/types/dashboard-config.type';

const DashboardConfig = () => {
	const { t } = useTranslation('layout', { keyPrefix: 'dashboard' });

	const aside_config: IDashboardConfig = {
		forex_dashboard: {
			title: t('FOREX_DASHBOARD'),
			links: [
				{
					title: t('Wallet'),
					icon: <FundingWalletOutline />,
					link: 'dashboard',
				},
				{
					title: t('Open_Account'),
					icon: <AddSquareOutline />,
					link: 'dashboard/accounts',
				},
				{
					title: t('IB_Dashboard'),
					icon: <UsersOutline />,
					link: 'dashboard/accounts',
					sub: [
						{
							title: t('Overview'),
							link: 'dashboard/ib',
						},
						{
							title: t('Links'),
							link: 'dashboard/ib/links',
						},
						{
							title: t('Acquisitions'),
							link: 'dashboard/ib/acquisitions',
						},
						{
							title: t('Client_List'),
							link: 'dashboard/ib/client-list',
						},
						{
							title: t('Accounts'),
							link: 'dashboard/ib/accounts',
						},
						{
							title: t('Rewards'),
							link: 'dashboard/ib/rewards',
						},
						{
							title: t('Transactions'),
							link: 'dashboard/ib/transactions',
						},
					],
				},
				{
					title: t('Positions_Orders'),
					icon: <PnlOutline />,
					link: 'dashboard/trade-history',
				},
				{
					title: t('Transactions_History'),
					icon: <HistoryOutline />,
					link: 'dashboard/transactions-history',
				},
			],
		},
	};
	return aside_config;
};

export default DashboardConfig;
